module.exports = __webpack_public_path__ + "static/media/icon_dining.c7b09b80.svg";